// Utils
import NiceSelect from './utils/jquery.nice-select';
import StyledDropdown from './utils/styled-dropdowns';
import SlickSliderSettings from './utils/slick-theme-settings';

// Templates
import CartTemplate from './templates/cart';
import Account from './templates/customers/account';
import LoginForm from './templates/customers/login';
import RegisterForm from './templates/customers/register';
import Addresses from './templates/customers/addresses';
import BlogTemplate from './templates/blog';
import ArticleTemplate from './templates/article';
import PDPTemplate from './templates/pdp';
import ProductRecommendation from './templates/pdp/product-recommendations-slider';
import PageFlexibleContentModulesTemplate from './templates/page.flexible-content-modules';

// Sections
import CartDrawer from './sections/cart-drawer';

// Components
import Components from './components/index';

// Dynamic Yield
import DyNewsletterPullUpExperience from './utils/dynamic-yield/dy-newsletter-pullup';

//
import BoldSubscriptionWidget from './vendors/bold-subscription-widget/index';

export default {
  init: () => {
    Components();
    StyledDropdown();
    SlickSliderSettings();
    NiceSelect();
  
    CartTemplate();
    CartDrawer();
    BlogTemplate();
    PDPTemplate();
    ArticleTemplate();
    PageFlexibleContentModulesTemplate();
    Addresses();
    LoginForm();
    RegisterForm();
  
    Account();
  
    DyNewsletterPullUpExperience();
    BoldSubscriptionWidget();
  },
  ProductRecommendation,
};